import { getUserPermissionList } from "./StorageHelper";

export const permissionSlugs = {
  staff: "staff",
  staff_role: "staff.role",
  staff_role_list: "staff.role.list",
  staff_role_create: "staff.role.create",
  staff_role_edit: "staff.role.edit",
  staff_role_export: "staff.role.export",
  staff_list: "staff.list",
  staff_create: "staff.create",
  staff_edit: "staff.edit",
  staff_delete: "staff.delete",
  staff_export: "staff.export",
  dealer: "dealer",
  dealer_report: "dealer.report",
  dealer_report_list: "dealer.report.list",
  dealer_report_edit: "dealer.report.edit",
  dealer_report_lock_unlock: "dealer.report.lock.unlock",
  dealer_report_change_role: "dealer.report.change.role",
  dealer_report_delete: "dealer.report.delete",
  dealer_report_export: "dealer.report.export",
  dealer_reward_point: "dealer.reward.point",
  dealer_reward_point_export: "dealer.reward.point.export",
  dealer_reward_summary: "dealer.reward.summary",
  dealer_reward_summary_export: "dealer.reward.summary.export",
  dealer_ticket: "ticket.dealer",
  dealer_hide_mobile_number: "hide.mobile.number.dealer",
  verify_dealer_account: "verify.dealer.account",
  verify_dealer_account_list: "verify.dealer.account.list",
  verify_dealer_account_accept_reject: "verify.dealer.account.accept.reject",
  verify_dealer_account_export: "verify.dealer.account.export",
  sub_dealer: "sub.dealer",
  sub_dealer_report: "sub.dealer.report",
  sub_dealer_report_list: "sub.dealer.report.list",
  sub_dealer_report_edit: "sub.dealer.report.edit",
  sub_dealer_report_lock_unlock: "sub.dealer.report.lock.unlock",
  sub_dealer_report_change_role: "sub.dealer.report.change.role",
  sub_dealer_report_delete: "sub.dealer.report.delete",
  sub_dealer_report_export: "sub.dealer.report.export",
  sub_dealer_reward_point: "sub.dealer.reward.point",
  sub_dealer_reward_point_export: "sub.dealer.reward.point.export",
  sub_dealer_reward_summary: "sub.dealer.reward.summary",
  sub_dealer_reward_summary_export: "sub.dealer.reward.summary.export",
  sub_dealer_ticket: "ticket.sub.dealer",
  sub_dealer_hide_mobile_number: "hide.mobile.number.sub.dealer",
  verify_sub_dealer_account: "verify.sub.dealer.account",
  verify_sub_dealer_account_list: "verify.sub.dealer.account.list",
  verify_sub_dealer_account_accept_reject:
    "verify.sub.dealer.account.accept.reject",
  verify_sub_dealer_account_export: "verify.sub.dealer.account.export",
  technician: "technician",
  technician_report: "technician.report",
  technician_report_list: "technician.report.list",
  technician_report_edit: "technician.report.edit",
  technician_report_lock_unlock: "technician.report.lock.unlock",
  technician_report_change_role: "technician.report.change.role",
  technician_report_delete: "technician.report.delete",
  technician_report_export: "technician.report.export",
  technician_reward_point: "technician.reward.point",
  technician_reward_point_export: "technician.reward.point.export",
  technician_reward_summary: "technician.reward.summary",
  technician_reward_summary_export: "technician.reward.summary.export",
  technician_ticket: "ticket.technician",
  technician_hide_mobile_number: "hide.mobile.number.technician",
  report: "report",
  otp_report: "otp.report",
  otp_report_list: "otp.report.list",
  scan_code_report: "scan.code.report",
  scan_code_report_list: "scan.code.report.list",
  scan_code_report_export: "scan.code.report.export",
  whatsapp_message_report: "whatsapp.message.report",
  whatsapp_message_report_list: "whatsapp.message.report.list",
  whatsapp_message_report_export: "whatsapp.message.report.export",
  check_user_detail_report: "check.user.detail.report",
  check_user_detail_report_list: "check.user.detail.report.list",
  monthwise_scan_percentage_report: "month.wise.scan.percentage.report",
  bonus_point: "bonus.point",
  bonus_point_achiever: "bonus.point.achiever",
  bonus_point_achiever_list: "bonus.point.achiever.list",
  bonus_point_achiever_export: "bonus.point.achiever.export",
  overall_reward_achieved: "overall.reward.achieved",
  overall_reward_achieved_list: "overall.reward.achieved.list",
  overall_reward_achieved_export: "overall.reward.achieved.export",
  overall_point_achieved: "overall.point.achieved",
  overall_point_achieved_list: "overall.point.achieved.list",
  overall_point_achieved_export: "overall.point.achieved.export",
  overall_reward_redeem: "overall.reward.redeem",
  overall_reward_redeem_list: "overall.reward.redeem.list",
  overall_reward_redeem_export: "overall.reward.redeem.export",
  // user detail
  category: "category",
  category_report: "category.report",
  category_report_list: "category.report.list",
  create_category_report: "create.category.report",
  edit_category_report: "edit.category.report",
  export_category_report: "export.category.report",
  achievement_order: "achievement.order",
  manage_achievement_order: "manage.achievement.order",
  catalog: "catalog",
  catalog_report: "catalog.report",
  catalog_report_list: "catalog.report.list",
  create_catalog_report: "create.catalog.report",
  edit_catalog_report: "edit.catalog.report",
  delete_catalog_report: "delete.catalog.report",
  export_catalog_report: "export.catalog.report",
  catalog_order: "catalog.order",
  manage_catalog_order: "manage.catalog.order",
  outlet: "outlet",
  outlet_list: "outlet.list",
  edit_outlet: "edit.outlet",
  export_outlet: "export.outlet",
  seminar: "seminar",
  seminar_list: "seminar.list",
  create_seminar: "create.seminar",
  edit_seminar: "edit.seminar",
  delete_seminar: "delete.seminar",
  export_seminar: "export.seminar",
  seminar_booking: "seminar.booking",
  seminar_booking_list: "seminar.booking.list",
  seminar_booking_edit: "seminar.booking.edit",
  seminar_booking_delete: "seminar.booking.delete",
  seminar_booking_export: "seminar.booking.export",
  notification: "notification",
  manual_notification: "manual.notification",
  list_manual_notification: "list.manual.notification",
  create_manual_notification: "create.manual.notification",
  edit_manual_notification: "edit.manual.notification",
  delete_manual_notification: "delete.manual.notification",
  setting: "setting",
  maintenance_setting: "maintenance.setting",
  edit_maintenance_setting: "edit.maintenance.setting",
  whatsapp_notification_setting: "whatsapp.notification.setting",
  edit_whatsapp_notification_setting: "edit.whatsapp.notification.setting",
  auto_notification_setting: "auto.notification.setting",
  edit_auto_notification_setting: "edit.auto.notification.setting",
  contact_setting: "contact.setting",
  edit_contact_setting: "edit.contact.setting",
  other: "other",

  //first banner
  app_banner: "app.banner",
  app_banner_list: "app.banner.list",
  edit_app_banner: "edit.app.banner",

  // forth banner
  banner_secondary: "banner.secondary",
  banner_secondary_list: "banner.secondary.list",
  create_banner_secondary: "create.banner.secondary",
  edit_banner_secondary: "edit.banner.secondary",

  //second banner
  banner_report: "banner.report",
  create_banner_report: "create.banner.report",
  banner_report_list: "banner.report.list",
  delete_banner_report: "delete.banner.report",
  manage_banner_report_order: "manage.banner.report.order",

  //third banner
  banner_announcement: "banner.announcement",
  create_banner_announcement: "create.banner.announcement",
  banner_announcement_list: "banner.announcement.list",
  delete_banner_announcement: "delete.banner.announcement",
  manage_banner_announcement_order: "manage.banner.announcement.order",

  //tutorial video
  tutorial_report: "tutorial.report",
  tutorial_report_list: "tutorial.report.list",
  create_tutorial_report: "create.tutorial.report",
  edit_tutorial_report: "edit.tutorial.report",
  delete_tutorial_report: "delete.tutorial.report",
  export_tutorial_report: "export.tutorial.report",
  manage_tutorial_order: "manage.tutorial.order",

  //catalog video
  catalog_video: "catalog.video",
  catalog_video_list: "catalog.video.list",
  create_catalog_video: "create.catalog.video",
  edit_catalog_video: "edit.catalog.video",
  delete_catalog_video: "delete.catalog.video",
  export_catalog_video: "export.catalog.video",
  manage_catalog_video_order: "manage.catalog.video.order",

  //startup_banner
  startup_banner: "startup.banner",
  startup_banner_list: "startup.banner.list",
  create_startup_banner: "create.startup.banner",
  edit_startup_banner: "edit.startup.banner",
  delete_startup_banner: "delete.startup.banner",
  export_startup_banner: "export.startup.banner",
  manage_startup_banner_order: "manage.startup.banner.order",

  lock_user: "lock.user",
  lock_user_list: "lock.user.list",
  lock_user_unlock: "lock.user.unlock",
  lock_user_export: "lock.user.export",
  fault_type: "fault.type",
  fault_type_list: "fault.type.list",
  create_fault_type: "create.fault.type",
  edit_fault_type: "edit.fault.type",
  delete_fault_type: "delete.fault.type",
  export_fault_type: "export.fault.type",
  reward: "reward",
  scan_reward: "scan.reward",
  scan_reward_list: "scan.reward.list",
  create_scan_reward: "scan.reward.create",
  edit_scan_reward: "scan.reward.edit",
  export_scan_reward: "scan.reward.export",
  create_ticket: "ticket.create",
  ticket_list: "ticket.list",
  ticket_export: "export.ticket",
  assign_ticket: "assign.ticket",

  marquee_type: "marquee.report",
  marquee_type_list: "marquee.report.list",
  create_marquee_type: "create.marquee.report",
  edit_marquee_type: "edit.marquee.report",
  delete_marquee_type: "delete.fault.type",
  export_marquee_type: "export.marquee.report",

  terms_and_conditions: "terms.and.conditions",

  ticket_verify_dealer: "ticket.verify.dealer",
  ticket_verify_sub_dealer: "ticket.verify.sub.dealer",

  company_dealer_replaced_product: "company.dealer.replaced.product",
  company_dealer_replaced_product_list: "company.dealer.replaced.product.list",
  company_dealer_replaced_product_export:
    "company.dealer.replaced.product.export",

  cart_report: "cart.report",
  cart_report_list: "cart.report.list",
  cart_report_export: "cart.report.export",

  dealer_additional_warranty: "dealer.additional.warranty",
  dealer_additional_warranty_list: "dealer.additional.warranty.list",
  dealer_additional_warranty_export: "dealer.additional.warranty.export",

  dealer_additional_warranty_replacement:
    "dealer.additional.warranty.replacement",
  dealer_additional_warranty_replacement_list:
    "dealer.additional.warranty.replacement.list",
  dealer_additional_warranty_replacement_export:
    "dealer.additional.warranty.replacement.export",

  // master registration
  master_registration_report: "master.registration.report",
  master_registration_report_list: "master.registration.report.list",
  master_registration_report_export: "master.registration.report.export",

  // scan code manual
  scan_code_manual: "scan.code.manual",

  whats_new: "whats.new",
  whats_new_report: "whats.new.report",
  whats_new_report_list: "whats.new.report.list",
  create_whats_new_Report: "create.whats.new.report",
  edit_whats_new_Report: "edit.whats.new.report",
  delete_whats_new_Report: "delete.whats.new.report",
  export_whats_new_Report: "export.whats.new.report",
  whats_new_order: "whats.new.order",
  manage_whats_new_order: "manage.whats.new.order",

  // CHANGE
  // five star levels
  fivestar_levels_list: "fiveStar.levels",
  fivestar_levels_conditions_list: "fiveStar.levels.conditions",
  fivestar_gift_list: "fivestar.gift.list",
  edit_five_star_gift: "fivestar.gift.edit",
  delete_five_star_gift: "fivestar.gift.delete",
  export_five_star_gift: "fivestar.gift.export",
  edit_five_star_levels: "fiveStar.levels.edit",
  delete_five_star_levels: "fiveStar.levels.delete",
  export_five_star_levels: "fiveStar.levels.export",
  edit_five_star_levels_conditions: "fiveStar.levels.conditions.edit",
  delete_five_star_levels_conditions: "fiveStar.levels.conditions.delete",
  export_five_star_level_conditions: "fiveStar.levels.conditions.export",
  fivestar_report_list: "fivestar.reports",
  fivestar_gift_report_list: "fivestar.gift.reports.list",
  fivestar_report_export: "fivestar.report.export",
  fivestar_gift_whatsapp_messages_report_list: "fivestar.gift.bulk.whatsapp.list",

  export_achieved_points_report:
    "level.reference.achieved.points.report.export",
  bonus_point_report_list: "dealer.bonus.points.report.list",

  edit_fix_scan_reference_report: "fix.scan.reference.report.edit",
  delete_fix_scan_reference_report: "fix.scan.reference.report.delete",
  fix_scan_reference_report_export: "fix.scan.reference.report.export",

  edit_level_reference_points_report: "level.reference.points.report.edit",
  delete_level_reference_points_report: "level.reference.points.report.delete",
  level_reference_points_report_export: "level.reference.points.report.export",

  edit_milestone_reference_points_report:
    "milestone.reference.points.report.edit",
  delete_milestone_reference_points_report:
    "milestone.reference.points.report.delete",
  milestone_reference_points_report_export:
    "milestone.reference.points.report.export",

  edit_target_points_reference_report: "target.points.reference.report.edit",
  delete_target_points_reference_report:
    "target.points.reference.report.delete",
  target_points_reference_report_export:
    "target.points.reference.report.export",

  account_log_details_export: "account.log.details.export",
  overall_bike_reward_report_export: "overall.bike.reward.export",
  overall_reward_report_export: "overall.reward.report.export",

  edit_bike_reward: "bike.reward.update",
  bike_reward_export: "bike.reward.insert",

  edit_congratulations_image_upload: "congratulations.image.upload.edit",
  delete_congratulations_image_upload: "congratulations.image.upload.delete",
  congratulations_image_upload_export: "congratulations.image.upload",

  edit_dealer_bonus_points: "dealer.bonus.points.report.edit",
  delete_dealer_bonus_points: "dealer.bonus.points.report.delete",

  inward_outward_list_export: "inward.outward.export",

  edit_points_redeem_options: "points.redeem.options.edit",
  delete_points_redeem_options: "points.redeem.options.delete",
  points_redeem_options_export: "points.redeem.options",

  edit_technicians_first_reward_report: "technical.first.reward.report.edit",
  delete_technicians_first_reward_report:
    "technical.first.reward.report.delete",

  technicians_first_reward_report_export: "technical.first.reward.report",

  dealer_purchase_report_export: "dealer.purchase.report.export",
  dealer_redeemable_products_report_export: "dealer.redeemable.products.export",
  dealer_sales_report_export: "dealer.sales.report.export",
  dealer_to_be_replacement_product_export: "dealer.to.be.replacement.product",
  product_given_warranty_export: "product.given.warranty",
  technician_claimed_company_warranty_export:
    "technician.claimed.company.warranty",
  eligible_technician_lucky_draw_report_export:
    "eligible.technician.lucky.draw.report.export",
  eligible_technician_lucky_draw_report_oct_dec_export:
    "eligible.technician.lucky.draw.report.(Oct-Dec).export",
  quarter_2022_jul_aug_export: "quarter.2022.jul-aug.export",
  quarter_2022_oct_dec_export: "quarter.2022.oct-Dec.export",
  achieved_points_report_export: "achieved.points.report.export",
  target_points_achieved_points_report_export:
    "target.points.achieved.points.report",
  milestone_points_achieved_points_report_export:
    "milestone.points.achieved.points.report",
  level_reference_achieved_points_report_export:
    "level.reference.achieved.points.report",
  fix_scan_achieved_points_report_export: "fix.scan.achieved.points.report",
  lucky_draw_report_export: "lucky.draw.report.export",
  overall_bike_reward_export: "overall.bike.reward.export",
  admin_add_points_old_export: "admin.add.points.old",
  dealer_bonus_points_export: "dealer.bonus.points.report.export",
  technicians_first_reward_export: "technical.first.reward.report.export",
  sub_dealer_purchase_report_export: "Sub-Dealer.Purchase.report.export",
  sub_dealer_redeemable_products_export:
    "sub-Dealer.redeemable.products.export",
  sub_dealer_sales_report_export: "Sub-Dealer.sales.report.export",
  technicians_purchase_report_export: "technical.Purchase.report.export",
  technicians_redeemable_products_export:
    "technical.redeemable.products.export",

  // dealer
  dealer_redeemable_products_list: "dealer.redeemable.products",
  dealer_sales_report_list: "dealer.sales.report",
  dealer_purchase_report_list: "dealer.purchase.report",

  // sub-dealer
  sub_dealer_redeemable_products_list: "sub-Dealer.redeemable.products",
  sub_dealer_sales_report_list: "Sub-Dealer.sales.report",
  sub_dealer_purchase_report_list: "Sub-Dealer.Purchase.report",

  // technician
  technician_redeemable_products_list: "technical.redeemable.products",
  technician_purchase_report_list: "technical.Purchase.report",

  // overall reward
  overall_reward_report_list: "overall.reward.report",
  overall_bike_reward_list: "overall.bike.reward",
  lucky_draw_report_list: "lucky.draw.report",

  // account log
  account_log_details_list: "account.log.details",

  create_bike_reward: "bike.reward.Create",
  update_bike_reward: "bike.reward.update",

  create_points_redeem_options: "points.redeem.option.create",
  list_points_redeem_options: "points.redeem.options.list",

  technicians_first_reward_report: "technical.first.reward.report.export",
  dealer_bonus_points_report: "dealer.bonus.points.report",
  dealer_bonus_points_insert: "dealer.bonus.points.insert",

  congratulations_image_upload_report: "congratulations.image.upload.list",
  congratulations_image_upload_insert: "congratulations.image.upload.insert",

  admin_add_points_old: "admin.add.points.old",
  inward_outward_list: "inward.outward.list",
  transfer_history_report: "wallet.transfer.history.list",
  transfer_history_report_export: "wallet.transfer.history.export",

  lucky_draw: "lucky.draw.campaign",
  fult: "fult",

  dealer_to_be_replacement_product: "dealer.to.be.replacement.product",
  technician_claimed_company_warranty: "technician.claimed.company.warranty",

  product_given_warranty: "product.given.warranty",

  referenceScheme: "referance.scheme",

  fix_scan_reference_report: "fix.scan.reference.report",
  fix_scan_reference_insert: "fix.scan.reference.insert",

  target_points_reference_report: "target.points.reference.report",
  target_points_reference_insert: "target.points.reference.insert",

  milestone_reference_points_report: "milestone.reference.points.report",
  milestone_reference_points_insert: "milestone.reference.points.insert",

  level_reference_points_report: "level.reference.points.report",
  level_reference_points_insert: "level.reference.points.insert",

  level_reference_achieved_points_report:
    "level.reference.achieved.points.report",
  fix_scan_achieved_points_report: "fix.scan.achieved.points.report",
  target_points_achieved_points_report: "target.points.achieved.points.report",
  milestone_points_achieved_points_report:
    "milestone.points.achieved.points.report",

  lucky_draw_campaign: "lucky.draw.campaign",
  quarter2022JulAug_list: "quarter.2022.jul-aug",
  quarter2022OctDec_list: "quarter.2022.oct-Dec",
  eligible_technician_lucky_draw_report:
    "eligible.technician.lucky.draw.report",
  eligible_technician_lucky_draw_report_oct_dec:
    "eligible.technician.lucky.draw.report.(Oct-Dec)",
  product_scan_reward_report: "product.scan.reward.report",

  // master barcode
  master_barcode_report_list: "master.barcode.report",
  master_barcode_balance_report_list: "master.barcode.balance.report",

  // global search
  global_search: "global.search",

  // store category
  store_category_list: "store.category.list",
  store_category_export: "store.category.export",
  store_category_create: "store.category.create",
  store_category_edit: "store.category.edit",
  store_category_delete: "store.category.delete",

  // store product
  store_product_list: "store.product.list",
  store_product_export: "store.product.export",
  store_product_create: "store.product.create",
  store_product_edit: "store.product.edit",
  store_product_delete: "store.product.delete",

  // wallet transaction
  wallet_transaction_report_list: "wallet.transaction.report.list",
  export_wallet_transaction_report: "export.wallet.transaction.report",

  referral_coin_used_report_list: "referral.coin.used.report.list",
  referral_coin_used_report_export: "referral.coin.used.report.export",

  wallet_transaction_list: "wallet.transaction.list",
  wallet_transaction_create: "wallet.transaction.create",
  wallet_transaction_export: "export.wallet.transaction"
};
// export const checkUserPermission = (functionalityName: string) => {
//   const permissionList = getUserPermissionList();
//   console.log(permissionList);

//   switch (functionalityName) {
//     case 'company_list':
//       return permissionList.includes('company.list');
//     case 'create_company':
//       return permissionList.includes('create.company');
//     case 'edit_company':
//       return permissionList.includes('edit.company');
//     case 'other':
//       return true;
//     default:
//       return false;
//   }
// };
export const hasUserAccessFunctionality = (functionalityName) => {
  const hasPermission = checkUserPermissionList(functionalityName);
  return hasPermission;
};
export const checkUserPermissionList = (functionalityList) => {
  const permissionList = getUserPermissionList();
  permissionList.push("other");
  const hasPermission = permissionList.some((path) =>
    functionalityList.includes(path)
  );
  return hasPermission;
};
